import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
import MUITooltip from '../../common/MUITooltip';
import Colors from 'js/constants/colors';

const wrapInDiv = (tooltipText) => {
    // Split the string by <br> tag (case-insensitive)
    const parts = tooltipText?.split(/<br\s*\/?>/i);

    return (
        <div>
            {parts.map((part, index) => (
                <div key={index} style={{ textAlign: 'left' }}>
                    {part?.trim()}
                </div>
            ))}
        </div>
    );
};

const EventTags = ({ label, color, tooltipText }) => (
    <MUITooltip
        arrow
        title={wrapInDiv(tooltipText)}
        PopperProps={{
            sx: { zIndex: 9999 }
        }}
    >
        <Chip
            data-testid={`chip-${color}`}
            label={label}
            size="small"
            sx={{
                backgroundColor: Colors[color],
                borderRadius: '4px',
                minWidth: '80px',
                mr: '10px',
                color: Colors.WHITE,
                textTransform: 'uppercase',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '1.5px',
                '& .MuiChip-label': {
                    fontSize: '10px',
                    overflow: 'unset',
                },
            }}
        />
    </MUITooltip>
);

EventTags.propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
    tooltipText: PropTypes.string,
};

export default EventTags;
